import { Component, Input, NgZone, OnInit } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { PlanItemI } from 'src/app/interfaces/plans.interface';
import { LoadingService } from 'src/app/services/misc/loading.service';
import { BrowserService } from 'src/app/services/native/browser.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { IUserData } from 'src/app/services/user/user-data.interface';
import { UserDataService } from 'src/app/services/user/user-data.service';
@Component({
  selector: 'app-plan-card',
  templateUrl: './plan-card.component.html',
  styleUrls: ['./plan-card.component.scss'],
})
export class PlanCardComponent implements OnInit {
  @Input() item: PlanItemI;

  userData: IUserData;
  loadedOK = false;

  constructor(
    private userDataService: UserDataService,
    private navigationService: NavigationService,
    private loadingService: LoadingService,
    private browserService: BrowserService,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.loadData();
  }

  async loadData() {
    this.userData = await this.userDataService.refreshUserInfo();
    this.loadedOK = true;
  }

  blog(): void {
    const url = `https://tributosimple.com/terminos-y-condiciones/`;
    const preventManualExit = false;

    const browser = this.browserService.open(url, '_blank');

    if (browser) {
      browser.on('loadstart').subscribe((event) => {
        console.log('loadstart - event: ', event);
      });

      browser.on('loadstop').subscribe((event) => {
        console.log('loadstop - event: ', event);
      });

      browser.on('exit').subscribe((event) => {
        if (!preventManualExit) {
          this.ngZone.run(() => {
            console.log('Usuario cerró manualmente el navegador.');
          });
        }
        console.log('exit - event: ', event);
      });
    }
  }

  async purchase() {
    await this.loadingService.present();
    const navigationExtras: NavigationExtras = { state: { uusuarioTSID: this.userData.id, itemId: this.item.id } };

    this.navigationService.navigateRoot('/mp-checkout', navigationExtras);
    this.loadingService.dismiss();
  }

  async goHome() {
    this.navigationService.navigateRoot('/home');
  }
}
